import { HttpClient } from "@angular/common/http";
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatAccordion } from "@angular/material/expansion";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { fuseAnimations } from "@fuse/animations";
import { FuseConfirmDialogComponent } from "@fuse/components/confirm-dialog/confirm-dialog.component";
import { TranslateService } from "@ngx-translate/core";
import { UiService } from "app/helper-components/UiService";
import { BreadCrumbsService } from "app/helper-components/breadcrumbs/breadcrumbs.service";
import { Constants } from "app/helpers/Constants";
import { BoothDataService } from "app/helpers/booth-data.service";
import { HelperService } from "app/helpers/helper.service";
import { PostService } from "app/helpers/post.service";
import { UserDataService } from "app/helpers/user-data.service";
import { environment } from "environments/environment";
import { AddboothFormComponent } from "./addbooth-form/addbooth-form.component";
import { ConformGenderComponent } from "./conform-gender/conform-gender.component";
import { EditVotsComponent } from "./edit-vots/edit-vots.component";

@Component({
  selector: "app-constituency-booth",
  templateUrl: "./constituency-booth.component.html",
  styleUrls: ["./constituency-booth.component.scss"],
  animations: fuseAnimations,
  encapsulation: ViewEncapsulation.None,
})
export class ConstituencyBoothComponent implements OnInit, AfterViewInit {
  @ViewChild("extra_container", { read: ElementRef })
  extra_container: ElementRef;
  @ViewChild(MatAccordion) accordion: MatAccordion;
  showVots = false;
  dialogRef: any;
  confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;
  electionList: any;
  filterbooths: any = [];

  private isViewInit = false;

  public booth: string = "";
  public area: string = "";
  public booth_no: string = "";
  public hideIt = false;
  public showPlaceHolder = false;
  public card_color = "";
  public showAddButton = false;
  public bothResult: any;
  isChecked: boolean;

  public callback = function () {
    //Card Click Callback
  };

  public afterViewInit = () => {};
  parameters: any;
  boothList: any;
  votsList: any;
  cards: any[] = [];
  page = 1;

  constructor(
    private cdr: ChangeDetectorRef,
    private helper: HelperService,
    private activatedRoute: ActivatedRoute,
    private postService: PostService,
    private _matDialog: MatDialog,
    private uiService: UiService,
    private userService: UserDataService,
    private _translate: TranslateService,
    private _snackBar: MatSnackBar,
    private router: Router,
    private userDataService: UserDataService,
    private httpClient: HttpClient,
    private breadCrumbsService: BreadCrumbsService,
    private boothDataService: BoothDataService,
    private el: ElementRef
  ) {
    this.card_color = helper.getRandomColor(6);
    // this.boothList = this.boothDataService.checkBoothData();
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((data) => {
      this.parameters = this.helper.getParameters(data["_v"]);
      // this.parameters = this.helper.getParameters(data["_v"]);
      // this.breadCrumbsService.addBreadCrumb("..", "/const_booth?_v=" + data);
      // "/const_booth?_v=" + key
      if (this.parameters.party_post_group_id == 11) {
        this.breadCrumbsService.addBreadCrumb(
          this.parameters.section_name + " நகராட்சி",
          "/post/constituency/" + data["_v"]
        );
      } else {
        this.breadCrumbsService.addBreadCrumb(
          this.parameters.const_name + " தொகுதி",
          "/post/constituency/" + data["_v"]
        );
      }
    });

    var rights =
      this.userDataService.userData.rights[this.parameters.party_post_id];
    this.showAddButton = this.helper.editAccessAvailable(
      rights,
      this.parameters,
      Constants.ASSEMBLY_STRUCTURE_EDIT
    );
    // this.boothDataService.getPlaceId(this.parameters.place_id);
    // this.loadData();
    // this.boothList = this.boothDataService.checkBoothData(
    //   this.parameters.place_id
    // );
    // if (!this.boothList) {
    this.loadBoothList();
    // } else {
    //   this.filterbooths = [...this.boothList];

    //   this.filterbooths.forEach((element) => {
    //     element.card_color =
    //       element.party_persons?.length == 3
    //         ? "#00a000"
    //         : element.party_persons?.length == 0
    //         ? "#a00000"
    //         : "#777700";
    //   });
    // }
    // });
  }

  // @HostListener("scroll", ["$event"])
  // onScroll(event: any) {
  //   // Check if the user has scrolled to the bottom of the .courses div
  //   const element = this.el.nativeElement.querySelector(".courses");
  //   if (element) {
  //     const atBottom =
  //       element.scrollTop + element.clientHeight + 1 >=
  //       element.scrollHeight - 400;

  //     if (atBottom) {
  //       this.page++;
  //       this.loadData();
  //     }
  //   }
  // }

  // loadData(): void {
  //   this.boothDataService.fetchData(this.page).subscribe((result: any) => {
  //     // Append the new data to the existing data array
  //     this.cards = this.cards.concat(result.data);
  //   });
  // }
  loadBoothList() {
    this.boothList = this.boothDataService.checkBoothData(
      this.parameters.place_id
    );
    // localStorage.setItem("BoothPlaceId", this.parameters.place_id);
    // const BoothResult = localStorage.getItem("BoothPlaceId");

    if (this.boothList == undefined) {
      // this.bothResult = this.boothDataService.checkBoothData(
      //   this.parameters.place_id
      // );
      // if (this.bothResult == undefined) {
      this.uiService.showLoading();
      this.httpClient
        .get(environment.API_GET_BOOTHS, {
          headers: this.postService.getHeaders(),
          params: {
            place_id: this.parameters.place_id,
            group_id: "5",
            post_statistics: "1",
          },
        })
        .subscribe((val: any) => {
          this.boothList = val.data;
          this.boothDataService.storeBoothData(
            val.data,
            this.parameters.place_id
          );
          // this.boothDataService.storeBoothData(val.data);
          // localStorage.setItem("BoothPlaceId", this.parameters.place_id);

          this.filterbooths = [...this.boothList];

          this.filterbooths.forEach((element) => {
            element.card_color =
              element.party_persons?.length == 3
                ? "#00a000"
                : element.party_persons?.length == 0
                ? "#a00000"
                : "#777700";
          });

          this.uiService.hideLoading();
        });
    } else {
      this.filterbooths = [...this.boothList];

      this.filterbooths.forEach((element) => {
        element.card_color =
          element.party_persons?.length == 3
            ? "#00a000"
            : element.party_persons?.length == 0
            ? "#a00000"
            : "#777700";
      });
    }
  }
  ngAfterViewInit(): void {
    this.afterViewInit();
    this.isViewInit = true;

    this.electionList = this.userService.getAssemblyElections();
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  expandVots(booth: any) {
    this.uiService.showLoading();
    const formData = new FormData();
    formData.append("getBoothVotesData", "1");
    formData.append("const_id", this.parameters.const_id);
    formData.append("booth_id", booth.booth_id);
    formData.append("election_id", this.electionList[0].election_id);
    formData.append("election_type", this.electionList[0].election_type);

    this.postService.post(environment.API_VOTES, formData).subscribe((val) => {
      // this.votsList = val.data;
      booth.votesList = val.data;

      if (val.status == "success") {
        this.showVots = true;
      }
      if (booth.votesList.length > 0 && booth.votesList[0].votes_id == null) {
        booth.votesList[0].self = 0;
        booth.votesList[0].opp_1 = 0;
        booth.votesList[0].opp_2 = 0;
        booth.votesList[0].total_votes = 0;
      }
      this.uiService.hideLoading();
    });
  }

  onCardClick(): void {
    this.callback();
  }

  setAsPlaceHolder(): void {
    this.hideIt = true;
    this.showPlaceHolder = true;
  }

  showEmptyImage(event) {
    event.target.src = "/assets/images/empty_profile_male.jpg";
  }

  addExtraContainerElements(html: string): void {
    this.extra_container.nativeElement.innerHTML = html;
  }

  ngOnChanges(changes: SimpleChanges): void {}

  hideExtraContainer() {
    if (!this.isViewInit) return false;
    else
      return (
        !this.extra_container ||
        this.extra_container.nativeElement.innerHTML == ""
      );
  }

  getExtraContainerHtml(): string {
    if (this.extra_container)
      return this.extra_container.nativeElement.innerHTML;
    return "";
  }

  edit(booth: any) {
    this.dialogRef = this._matDialog.open(EditVotsComponent, {
      panelClass: "event-form-dialog",
      data: booth.votesList,
    });
    this.dialogRef.afterClosed().subscribe((val) => {
      if (val.data.status == "success") {
        this._translate.get("Successfully Added.").subscribe((msg) => {
          this._snackBar.open(msg, "Close", {
            panelClass: "snack-success",
          });
        });
        booth.votesList[0].self = val.selfvots;
        booth.votesList[0].opp_1 = val.opp_1;
        booth.votesList[0].opp_2 = val.opp_2;
        booth.votesList[0].total_votes = val.total;
        booth.votesList[0].votes_id = val.data.votes_id;
      }
    });
  }

  filterCardsByTerm = (searchTerm: string) => {
    this.filterbooths = this.boothList.filter((val: any) => {
      if (searchTerm.trim() == "") {
        return true;
      } else {
        if (val.booth.includes(searchTerm)) {
          return true;
        }
        if (val.area.includes(searchTerm)) {
          return true;
        }
        if (val.booth_number.toString().includes(searchTerm.trim())) {
          return true;
        }
      }
    });
  };

  onBoothCardClick(booth: any) {
    // this.parameters.place_id = booth.booth_id;
    // this.parameters.party_group_id = 14;
    // let key = this.helper.storePageData(this.parameters);
    // this.router.navigateByUrl("/post/list?_v=" + key);
  }

  addBooth() {
    this.dialogRef = this._matDialog.open(AddboothFormComponent, {
      panelClass: "event-form-dialog",
    });

    this.dialogRef.afterClosed().subscribe((val) => {
      if (val.status == "success") {
        this.uiService.showLoading();
        this.ngOnInit();
        this.uiService.hideLoading();
      }
    });
  }

  selectGender(booth: any) {
    this.dialogRef = this._matDialog.open(ConformGenderComponent, {
      panelClass: "event-form-dialog",
      data: booth.booth_id,
    });

    this.dialogRef.afterClosed().subscribe((val) => {
      if (val.status == "success") {
        this.uiService.showLoading();
        this.ngOnInit();
        this.uiService.hideLoading();
      } else {
        this.isChecked = false;
      }
    });
  }

  PartypostMemberList(data) {
    this.parameters.booth_id = data.booth_id;
    this.parameters.group_id = 9;
    this.parameters.parent_const_id = this.parameters.const_id;
    this.parameters.booth_number = data.booth_number;
    this.parameters.booth_area = data.area;
    this.parameters.booth_name = data.booth;
    this.parameters.booth_count = data.booth_count;
    let key = this.helper.storePageData(this.parameters);
    // this.router.navigateByUrl("/post/list?_v=" + key);
    window.open("/post/list?_v=" + key, "_blank");
  }
}
